"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadycableSchema = void 0;
const zod_1 = require("zod");
const NullableJsonValue_1 = require("../inputTypeSchemas/NullableJsonValue");
const InputJsonValue_1 = require("../inputTypeSchemas/InputJsonValue");
const DataSourceSchema_1 = require("../inputTypeSchemas/DataSourceSchema");
const ReadycableCategorySchema_1 = require("../inputTypeSchemas/ReadycableCategorySchema");
const ArticleSpecSchema_1 = require("../inputTypeSchemas/ArticleSpecSchema");
const ArticleTypeSchema_1 = require("../inputTypeSchemas/ArticleTypeSchema");
const LengthUnitSchema_1 = require("../inputTypeSchemas/LengthUnitSchema");
const WeightPerLengthUnitSchema_1 = require("../inputTypeSchemas/WeightPerLengthUnitSchema");
const TemperatureUnitSchema_1 = require("../inputTypeSchemas/TemperatureUnitSchema");
const VelocityUnitSchema_1 = require("../inputTypeSchemas/VelocityUnitSchema");
const AccelerationUnitSchema_1 = require("../inputTypeSchemas/AccelerationUnitSchema");
const ReadycableSubCategorySchema_1 = require("../inputTypeSchemas/ReadycableSubCategorySchema");
/////////////////////////////////////////
// READYCABLE SCHEMA
/////////////////////////////////////////
exports.ReadycableSchema = zod_1.z.object({
    dataSource: DataSourceSchema_1.DataSourceSchema,
    categories: ReadycableCategorySchema_1.ReadycableCategorySchema.array(),
    mainCategory: ReadycableCategorySchema_1.ReadycableCategorySchema,
    articleSpecs: ArticleSpecSchema_1.ArticleSpecSchema.array(),
    articleType: ArticleTypeSchema_1.ArticleTypeSchema,
    chainBendRadiusMinUnit: LengthUnitSchema_1.LengthUnitSchema,
    copperWeightUnit: WeightPerLengthUnitSchema_1.WeightPerLengthUnitSchema.nullish(),
    outerDiameterUnit: LengthUnitSchema_1.LengthUnitSchema,
    temperatureMaxUnit: TemperatureUnitSchema_1.TemperatureUnitSchema,
    temperatureMinUnit: TemperatureUnitSchema_1.TemperatureUnitSchema,
    weightUnit: WeightPerLengthUnitSchema_1.WeightPerLengthUnitSchema,
    speedMaxUnsupportedUnit: VelocityUnitSchema_1.VelocityUnitSchema.nullish(),
    accelerationMaxUnsupportedUnit: AccelerationUnitSchema_1.AccelerationUnitSchema.nullish(),
    travelDistanceUnsupportedUnit: LengthUnitSchema_1.LengthUnitSchema.nullish(),
    speedMaxGlidingUnit: VelocityUnitSchema_1.VelocityUnitSchema.nullish(),
    accelerationMaxGlidingUnit: AccelerationUnitSchema_1.AccelerationUnitSchema.nullish(),
    travelDistanceGlidingUnit: LengthUnitSchema_1.LengthUnitSchema.nullish(),
    speedMaxVerticalUnit: VelocityUnitSchema_1.VelocityUnitSchema.nullish(),
    accelerationMaxVerticalUnit: AccelerationUnitSchema_1.AccelerationUnitSchema.nullish(),
    travelDistanceVerticalUnit: LengthUnitSchema_1.LengthUnitSchema.nullish(),
    cableLengthUnit: LengthUnitSchema_1.LengthUnitSchema.nullish(),
    subCategory: ReadycableSubCategorySchema_1.ReadycableSubCategorySchema.nullish(),
    akeneoSku: zod_1.z.string(),
    akeneoUuid: zod_1.z.string().nullish(),
    discontinuedModel: zod_1.z.boolean(),
    echainId: zod_1.z.string(),
    chainflexRef: zod_1.z.string(),
    ecfAllowed: zod_1.z.boolean(),
    eicAllowed: zod_1.z.boolean(),
    eiqAllowed: zod_1.z.boolean(),
    ekeAllowed: zod_1.z.boolean(),
    artNr: InputJsonValue_1.InputJsonValue,
    chainBendRadiusMin: zod_1.z.number(),
    copperWeight: zod_1.z.number().nullish(),
    crossSection: InputJsonValue_1.InputJsonValue,
    description: InputJsonValue_1.InputJsonValue,
    nominalCrossSection: NullableJsonValue_1.NullableJsonValue.optional(),
    numberOfCores: zod_1.z.string(),
    numberOfCoresCalculated: zod_1.z.number().int().nullish(),
    outerDiameter: zod_1.z.number(),
    outerJacket: zod_1.z.string(),
    ralnumber: zod_1.z.string(),
    temperatureMax: zod_1.z.number(),
    temperatureMin: zod_1.z.number(),
    weight: zod_1.z.number(),
    unsupportedAllowed: zod_1.z.boolean(),
    speedMaxUnsupported: zod_1.z.number().nullish(),
    accelerationMaxUnsupported: zod_1.z.number().nullish(),
    travelDistanceUnsupported: zod_1.z.number().nullish(),
    glidingAllowed: zod_1.z.boolean(),
    speedMaxGliding: zod_1.z.number().nullish(),
    accelerationMaxGliding: zod_1.z.number().nullish(),
    travelDistanceGliding: zod_1.z.number().nullish(),
    verticalAllowed: zod_1.z.boolean(),
    speedMaxVertical: zod_1.z.number().nullish(),
    accelerationMaxVertical: zod_1.z.number().nullish(),
    travelDistanceVertical: zod_1.z.number().nullish(),
    fixedLength: zod_1.z.boolean(),
    cableLength: zod_1.z.number().nullish(),
    hasConnector: zod_1.z.boolean(),
    connector1: NullableJsonValue_1.NullableJsonValue.optional(),
    connector2: NullableJsonValue_1.NullableJsonValue.optional(),
    openEnd: zod_1.z.number().int().nullish(),
    manufacturer: zod_1.z.string().nullish(),
    manufacturerPartNo: zod_1.z.string().nullish(),
});
exports.default = exports.ReadycableSchema;
//# sourceMappingURL=ReadycableSchema.js.map